import { Button, Grid, Typography } from '@material-ui/core';
import React, { useState } from 'react';
import { useHistory } from 'react-router-dom';
import KenInputField from '../../../global_components/KenInputField';
import KenSelectWrap from '../../../global_components/KenSelect';
import KenLoader from '../../../Components/KenLoader/index';
import { universityOptions } from './data/data';
import { getAcademicFilter,postProgramBatchSpecialization } from '../../../Utils/apiServices';
const Specialization = (props) => {
  const defaultValues = {
    university: '',
    department: '',
    course: '',
    startDate: '',
    endDate: '',
    year: '',
    month: '',
  };
  const history = useHistory();
  const [formValues, setFormValues] = useState(defaultValues);
  const [specializationName, setSpecializationName] = React.useState('');
  const [courseOptions, setCourseOptions] = React.useState([]);
  const [loading, setLoading] = React.useState(false);
  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormValues({
      ...formValues,
      [name]: value,
    });
  };

  const handleFilters = () => {
    props.setFilters(formValues);
    props.setIsFiltered(true);
  };

  React.useEffect(() => {
    setLoading(true);
    getAcademicFilter()
      .then((res) => {
        let courseOptions = [];
        Object.entries(res['Academic Program']).map(([item, keyVal]) => {
          courseOptions.push({ label: item, value: item });
        });
        setCourseOptions(courseOptions);
        setLoading(false);
      })
      .catch((err) => {
        setLoading(false);
      });
  }, []);
  const addSpecialization = () => {
    let payload = {
      Program: {
        academicProgramsName: '',
        levelOfAcademicProgram: '',
        duration: {
          year: '',
          months: '',
        },
        numberofTerms: '',

        termduration: '',
      },
      Batch: {
        academicProgramsName: '',
        batchName: '',
        startDate: '',
        endDate: '',
        batchStrength: '',
        year: '',
        intake: '',
      },
      Specialization: {
        academicProgramsName: formValues.program,
        specializationName: specializationName,
      },
    };
    setLoading(true);
    postProgramBatchSpecialization(payload).then((res) => {
      console.log(res);
      if (res.success) {
        alert(res.message);
        setLoading(false);
        history.push('/app/current-programmes')
      }
    }).catch(err =>{
      setLoading(false);
    })
  };
  return (
    <Grid container spacing={2} style={{ maxWidth: 400 }}>
      {/* <Typography className={classes.heading}>Select Program</Typography> */}
      {loading && <KenLoader />}
      <Grid item xs={12}>
        <KenSelectWrap
          name="program"
          label="Program"
          options={courseOptions}
          value={formValues.program}
          dropdownColor="#FFFFFF"
          onChange={(e) => handleInputChange(e)}
          required
        />
      </Grid>
      <Grid item xs={12}>
        <KenInputField
          label="Specialization Name"
          required
          placeholder="Specialization Name"
          name="totalDay"
          onChange={(e) => setSpecializationName(e.target.value)}
          value={specializationName}
          // className={classes.textInputField}
        />
      </Grid>
       
      <Grid
        item
        xs={12}
        style={{ display: 'flex', justifyContent: 'flex-end' }}
      >
        <Button variant="outlined" onClick={handleFilters} style={{height: '37px', marginRight: '10px'}} >
          Cancel
        </Button>
        <Button
          variant="contained"
          color="primary"
          onClick={addSpecialization}
        >
          Submit
        </Button>
      </Grid>
    </Grid>
  );
};

export default Specialization;